import { render, staticRenderFns } from "./ReviewArea.vue?vue&type=template&id=535e4711&scoped=true&"
import script from "./ReviewArea.vue?vue&type=script&lang=ts&"
export * from "./ReviewArea.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewArea.vue?vue&type=style&index=0&id=535e4711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e4711",
  null
  
)

export default component.exports